import {
  BankClosureTool,
  CarBrandReliabilityTool,
  CarModelReliabilityTool,
  ChildBenefitCalculator,
  DividendTaxCalculator,
  IncomeTaxCalculator,
  MarriageAllowanceTool,
  NationalInsuranceCalculator,
  PensionCalculator,
  PensionWithdrawalCalculator,
} from './importers'

export const toolComponentMap = {
  bankClosure: {
    component: BankClosureTool,
    dataValidation: ['bank', 'branch', 'localAuthority', 'closingDate', 'postcode'],
  },
  carBrandReliability: {
    component: CarBrandReliabilityTool,
    dataValidation: ['brand', 'description', 'zero', 'five', 'ten', 'image'],
  },
  carModelReliability: {
    component: CarModelReliabilityTool,
    dataValidation: [
      'brand',
      'modelAndYear',
      'description',
      'zero',
      'five',
      'ten',
      'link',
      'image',
    ],
  },
  childBenefitCalculator: {
    component: ChildBenefitCalculator,
    dataValidation: ['taxYear', 'earningLimit', 'initialRate', 'additionalRate', 'amountOverLimit'],
  },
  councilTax: {
    component: BankClosureTool,
    dataValidation: ['country', 'area', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'],
  },
  dividendTaxCalculator: {
    component: DividendTaxCalculator,
    dataValidation: [
      'taxYear',
      'divAllowance',
      'basicThreshold',
      'higherThreshold',
      'additionalThreshold',
      'basicRate',
      'higherRate',
      'additionalRate',
    ],
  },
  incomeTaxCalculator: {
    component: IncomeTaxCalculator,
    dataValidation: [
      'taxYear',
      'personalAllowanceLimit',
      'lowRate',
      'midRate',
      'highRate',
      'lowThreshold',
      'midThreshold',
      'highThreshold',
      'startRateScot',
      'basicRateScot',
      'intermediateRateScot',
      'higherRateScot',
      'topRateScot',
      'lowThresholdScot',
      'startThresholdScot',
      'basicThresholdScot',
      'intermediateThresholdScot',
      'advancedThresholdScot',
      'highThresholdScot',
      'lowRateNi',
      'mediumRateNi',
      'highRateNi',
      'lowThresholdNi',
      'mediumThresholdNi',
    ],
  },
  marriageAllowance: {
    component: MarriageAllowanceTool,
    isRecordValid: (recordKeys) =>
      ['id', 'question', 'answer', 'text', 'conclusion'].some((key) => recordKeys.includes(key)),
  },
  nationalInsuranceCalculator: {
    component: NationalInsuranceCalculator,
    dataValidation: [
      'employedAdditional',
      'employedRate',
      'financialYear',
      'highRate',
      'lowRate',
      'lowThreshold',
      'mediumThreshold',
      'minLowThreshold',
      'selfAdditional',
      'selfRate',
    ],
  },
  pensionCalculator: {
    component: PensionCalculator,
    dataValidation: [
      'womenDob',
      'womenYears',
      'womenMonths',
      'womenPensionDate',
      'menDob',
      'menYears',
      'menMonths',
      'menPensionDate',
    ],
  },
  pensionWithdrawalCalculator: {
    component: PensionWithdrawalCalculator,
    dataValidation: [
      'taxYear',
      'personalAllowanceLimit',
      'taxFreePercentage',
      'lowRate',
      'midRate',
      'highRate',
      'lowThreshold',
      'midThreshold',
      'highThreshold',
      'lowThresholdScot',
      'startThresholdScot',
      'basicThresholdScot',
      'midThresholdScot',
      'highThresholdScot',
      'startRateScot',
      'basicRateScot',
      'midRateScot',
      'higherRateScot',
      'topRateScot',
    ],
  },
}

export type ComponentType = keyof typeof toolComponentMap
